import {StrMap} from "../interfaces/common";

export const languageMap:StrMap = {
  "en": "English",
  "sv": "Swedish",
  "da": "Danish",
  "fi": "Finnish",
  "no": "Norwegian",
  "de": "German",
  "fr": "French",
  "it": "Italian",
  "es": "Spanish",
}

export const getLanguage = (language: string|null) => {
  if (!language) {
    return 'en'
  }
  if (language.startsWith('sv')) {
    return 'sv'
  }
  return 'en'
}

export const showLanguageString = (lang: string, txtSv: string | null, txtEn: string | null) => {
  if (lang === "sv" && txtSv) return txtSv;
  else if (txtEn) return txtEn;
  else return "Missing description";
}